import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { apiGet, apiPut, apiPost } from '../../framework/client';

import { VehicleUsage } from '../../../common/application/model/VehicleUsage';
import { NewVehicleUsage } from '../../../common/application/model/NewVehicleUsage';
import { VehicleUsageType } from '../../../common/application/model/enums/VehicleUsageType';

export async function postVehicleUsage(vehicleUsage: NewVehicleUsage): Promise<VehicleUsage> {
    const response = await apiPost(`/api/public/vehicle-usage`, vehicleUsage);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function putVehicleUsage(vehicleUsage: VehicleUsage): Promise<VehicleUsage> {
    const response = await apiPut(`/api/public/vehicle-usage/${vehicleUsage.id}`, vehicleUsage);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getVehicleUsage(
    id: string,
): Promise<{ vehicleUsage: VehicleUsage; vehicleRegistrationNumber: string | null }> {
    const response = await apiGet(`/api/public/vehicle-usage/${id}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getLatestVehicleUsage(
    vehicleRegistrationNumber: string,
): Promise<{ vehicleUsageAmount: number; vehicleUsageType: VehicleUsageType }> {
    const response = await apiGet(`/api/public/latest-vehicle-usage/${vehicleRegistrationNumber}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getVehicleUsageForCustomer(customerIds: string[]): Promise<any> {
    const response = await apiPost(`/api/public/vehicle-usage/customer`, { customerId: customerIds });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
